import { render, staticRenderFns } from "./UploadProfilePhoto.vue?vue&type=template&id=f8a7d29a&"
import script from "./UploadProfilePhoto.vue?vue&type=script&lang=js&"
export * from "./UploadProfilePhoto.vue?vue&type=script&lang=js&"
import style0 from "./UploadProfilePhoto.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/datavol/sites/sphir-ui-master/releases/20210903105233/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f8a7d29a')) {
      api.createRecord('f8a7d29a', component.options)
    } else {
      api.reload('f8a7d29a', component.options)
    }
    module.hot.accept("./UploadProfilePhoto.vue?vue&type=template&id=f8a7d29a&", function () {
      api.rerender('f8a7d29a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/mix/UploadProfilePhoto.vue"
export default component.exports